const appConfig = {
  apiGateways: {
    BASE_URL_1: `${process.env.REACT_APP_BACKEND_URL_HTTP}`
  },
  SOCKET_URL: `${process.env.REACT_APP_BACKEND_URL_WS}`,
  REACT_APP_ENV: process.env.REACT_APP_ENV || 'development'
}

export default appConfig
